import React from 'react';
import { FormattedNumber } from 'react-intl';
import { Link } from 'react-router-dom';

import { Headline } from '@xingternal/typography';

import styles from './contact-show-more.css';

interface Props {
  count: number;
  to: string;
}

const ContactShowMore: React.FC<Props> = ({ count, to }) => (
  <Link to={to} className={styles.container}>
    <Headline size="large" noMargin>
      +<FormattedNumber value={count} />
    </Headline>
  </Link>
);

export default ContactShowMore;
